import loginController from './login.controller';
import companyController from "./company.controller";
import roleController from "./role.controller";
import systemLogController from "./system-log.controller";
import systemParamController from "./system-param.controller";
import departmentController from "./department.controller";
import userController from "./user.controller";
import userDeviceController from "./user-device.controller";
import outsourceSettleController from "./outsource-settle.controller";
import resourceController from "./resource.controller";
export var managementService = {
    loginController: loginController,
    companyController: companyController,
    roleController: roleController,
    systemLogController: systemLogController,
    systemParamController: systemParamController,
    departmentController: departmentController,
    userController: userController,
    userDeviceController: userDeviceController,
    outsourceSettleController: outsourceSettleController,
    resourceController: resourceController,
};
